<template>
    <div class="sharelog" v-show="showlink">
        <div class="share-content">
            <div class="close-icon" @click="close">
                <img src="@/assets/close.png" alt="">
            </div>
            <div class="share-title">分享链接</div>
            <div class="share-btn-group">
                <div class="link-content">{{ link }}</div>
                <el-button type="primary" class="copy-btn" @click="copy">复制链接</el-button>
            </div>
            <div class="share-btn-group">
                <el-input class="pwd-input" v-model="password"></el-input>
                <el-button type="primary" class="copy-btn" @click="setpwd">设置密码</el-button>
            </div>
            <div class="share-tips">
                温馨提示：链接复制到浏览器中访问即可
                <!-- 温馨提示：链接有效期<em>7天</em>，过期后无法通过此链接访问 -->
            </div>
            <div class="share-group">
                <el-button type="primary" size="small" @click="close">确认</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { setProPwd } from '@/api/new';

export default {
    props: {
        link: {
            type: String,
            default: ''
        },
        showlink: {
            type: Boolean,
            default: false
        },
        proId: {
            type: [String, Number],
            default: ''
        },
        pwd: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            password: ''
        }
    },
    methods: {
        copy() {
            navigator.clipboard.writeText(this.link)
            .then(() => {
                this.$message.success('链接已复制到剪贴板')
            })
            .catch(err => {
                console.error('无法复制文本: ', err);
            });
        },
        setpwd() {
            const data = {
                id: this.proId,
                pwd: this.password,
                confirm_pwd: this.password
            }
            setProPwd(data).then(res => {
                if(res.code == 200) {
                    this.$message.success('设置项目访问密码成功')
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        close() {
            this.$emit('shareclose')
        }
    },
    watch: {
        pwd(n) {
            this.password = n
        }
    }
}
</script>

<style lang="scss" scoped>
.sharelog {
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, .3);
    z-index: 501;
    width: 100%;
    height: 100%;
    .share-content {
        width: 715px;
        height: 308px;
        background: #181A1B;
        box-shadow: 0px 3px 33px 0px #000000;
        border: 1px solid #3A3B3C;
        position: absolute;
        left: calc(50% - 357.5px);
        top: calc(50% - 154px);
        padding: 34px 36px;
        box-sizing: border-box;
    }
    .share-title {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #C0C0C0;
        line-height: 18px;
    }
    .share-btn-group {
        margin-top: 48px;
        display: flex;
        align-items: center;
        & + .share-btn-group {
            margin-top: 16px;
        }
    }
    .link-content {
        width: 521px;
        height: 40px;
        background: #212226;
        border-radius: 4px;
        border: 1px solid #3A3B3C;
        box-sizing: border-box;
        padding: 0 16px 0 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #FEFEFE;
        line-height: 40px;
        cursor: default;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .pwd-input {
        width: 521px;
        .el-input__inner {
            background: #212226;
            box-sizing: border-box;
            padding: 0 16px 0 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            line-height: 40px;
            color: #FEFEFE;
            border: 1px solid #3A3B3C;
        }
    }
    .copy-btn {
        margin-left: auto;
    }
    .share-tips {
        margin-top: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #C0C0C0;
        line-height: 16px;
        em {
            color: #0089FF;
        }
    }
    .share-group {
        display: flex;
        align-items: center;
        margin-top: 24px;
        row-gap: 8px;
    }
    .close-icon {
        width: 16px;
        height: 16px;
        position: absolute;
        right: 46px;
        top: 38px;
        cursor: pointer;
        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
<style lang="scss">

.pwd-input {
        width: 521px;
        .el-input__inner {
            background: #212226;
            box-sizing: border-box;
            padding: 0 16px 0 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            line-height: 40px;
            color: #FEFEFE;
            border: 1px solid #3A3B3C;
        }
    }
</style>